/* eslint-disable react-hooks/exhaustive-deps */

import React, { useLayoutEffect, useState } from "react";

import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";

import {
  Layout,
  Card,
  Table,
  Button,
  Space,
  Tag,
  Spin,
  Modal,
  Input,
  Collapse,
  Tabs,
  Badge,
  DatePicker,
} from "antd";

import {
    CalendarOutlined,
  CheckOutlined,
  CloseOutlined,
  EyeOutlined,
  ReloadOutlined,
  ThunderboltOutlined,
} from "@ant-design/icons";

import dayjs from "dayjs";

import { useNavigate } from "react-router-dom";

import { getAPI, postAPI, displayMessage } from "../../utils/common";

import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";

import {
  SMART_PRICE_PENDING,
  SMART_PRICE_APPROVED,
  SMART_PRICE_REJECTED,
  SMART_PRICE_EXPIRED,
  SMART_PRICE_APPROVE,
  SMART_PRICE_REJECT,
  SMART_PRICE_BULK_APPROVE,
  SMART_PRICE_BULK_REJECT,
  SMART_PRICE_GENERATE,
} from "../../constants/api";

function SmartPriceSuggestions() {
  const { Content } = Layout;

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [data, setData] = useState([]);

  const [status, setStatus] = useState("pending");

  const [selectedRows, setSelectedRows] = useState([]);

  const [rejectModal, setRejectModal] = useState(false);

  const [rejectReason, setRejectReason] = useState("");

  const [selectedId, setSelectedId] = useState(null);

  const [generateModal, setGenerateModal] = useState(false);

  const [generateDate, setGenerateDate] = useState(dayjs());

  const [pagination, setPagination] = useState({
    current: 1,

    pageSize: 20,

    total: 0,
  });

  useLayoutEffect(() => {
    getSuggestions();
  }, [status]);

  const generateSuggestions = (date = null) => {
    setLoading(true);

    postAPI(
      SMART_PRICE_GENERATE,
      {
        generated_date: date,
      },

      (res) => {
        setLoading(false);

        if (res.status) {
          displayMessage(
            SUCCESS_MESSAGE,
            res.message || "Suggestions generated successfully.",
          );

          setGenerateModal(false);

          getSuggestions();
        } else {
          displayMessage(ERROR_MSG_TYPE, res.message);
        }
      },

      () => {
        setLoading(false);
      },
    );
  };

  /*
|--------------------------------------------------------------------------
| API Mapping
|--------------------------------------------------------------------------
*/

  const getAPIURL = () => {
    switch (status) {
      case "pending":
        return SMART_PRICE_PENDING;

      case "approved":
        return SMART_PRICE_APPROVED;

      case "rejected":
        return SMART_PRICE_REJECTED;

      case "expired":
        return SMART_PRICE_EXPIRED;

      default:
        return SMART_PRICE_PENDING;
    }
  };

  /*
|--------------------------------------------------------------------------
| Get Suggestions
|--------------------------------------------------------------------------
*/

  const getSuggestions = (page = 1) => {
    setLoading(true);

    getAPI(
      getAPIURL() + "?page=" + page,

      (res) => {
        if (res.status) {
          setData(res.data.data || []);

          setPagination({
            current: res.data.current_page,

            pageSize: res.data.per_page,

            total: res.data.total,
          });
        }

        setLoading(false);
      },

      () => {
        setLoading(false);
      },

      {},
    );
  };

  /*
|--------------------------------------------------------------------------
| Single Approve
|--------------------------------------------------------------------------
*/

  const approveSuggestion = (id) => {
    setLoading(true);

    postAPI(
      SMART_PRICE_APPROVE,

      {
        id: id,

        approved_by: 1,
      },

      (res) => {
        if (res.status) {
          displayMessage(
            SUCCESS_MESSAGE,

            res.message || "Approved",
          );

          getSuggestions();
        } else {
          displayMessage(
            ERROR_MSG_TYPE,

            res.message,
          );
        }

        setLoading(false);
      },

      () => {
        setLoading(false);
      },
    );
  };

  /*
|--------------------------------------------------------------------------
| Single Reject
|--------------------------------------------------------------------------
*/

  const rejectSuggestion = () => {
    postAPI(
      SMART_PRICE_REJECT,

      {
        id: selectedId,

        rejected_by: 1,

        reason: rejectReason,
      },

      (res) => {
        if (res.status) {
          displayMessage(
            SUCCESS_MESSAGE,

            res.message || "Rejected",
          );

          setRejectModal(false);

          setRejectReason("");

          getSuggestions();
        } else {
          displayMessage(
            ERROR_MSG_TYPE,

            res.message,
          );
        }
      },
    );
  };

  /*
|--------------------------------------------------------------------------
| Bulk Approve
|--------------------------------------------------------------------------
*/

  const bulkApprove = () => {
    postAPI(
      SMART_PRICE_BULK_APPROVE,

      {
        ids: selectedRows,

        approved_by: 1,
      },

      (res) => {
        if (res.status) {
          displayMessage(
            SUCCESS_MESSAGE,

            res.message || "Bulk Approved",
          );

          setSelectedRows([]);

          getSuggestions();
        }
      },
    );
  };

  /*
|--------------------------------------------------------------------------
| Bulk Reject
|--------------------------------------------------------------------------
*/

  const bulkReject = () => {
    postAPI(
      SMART_PRICE_BULK_REJECT,

      {
        ids: selectedRows,

        rejected_by: 1,

        reason: "Bulk rejected",
      },

      (res) => {
        if (res.status) {
          displayMessage(
            SUCCESS_MESSAGE,

            res.message || "Bulk Rejected",
          );

          setSelectedRows([]);

          getSuggestions();
        }
      },
    );
  };

  const columns = [
    {
      title: "Room",

      render: (row) => (
        <>
          <b>{row.room?.room_name}</b>

          <br />

          <small>{row.room?.room_no}</small>
        </>
      ),
    },

    {
      title: "Current",

      dataIndex: "old_price",

      render: (v) => <Tag>₹ {v}</Tag>,
    },

    {
      title: "Suggested",

      dataIndex: "suggested_price",

      render: (v) => <Tag color="blue">₹ {v}</Tag>,
    },

    {
      title: "Change",

      dataIndex: "change_percentage",

      render: (v) => <Tag>{v}%</Tag>,
    },

    {
      title: "Score",

      dataIndex: "score",

      render: (v) => (
        <Tag color={v >= 20 ? "green" : v <= -10 ? "red" : "orange"}>{v}</Tag>
      ),
    },

    {
      title: "Direction",

      dataIndex: "direction",

      render: (v) => (
        <Tag
          color={
            v === "increase" ? "green" : v === "decrease" ? "red" : "orange"
          }
        >
          {v}
        </Tag>
      ),
    },

    {
      title: "AI Signals",

      render: (row) => (
        <Collapse
          items={[
            {
              key: "1",

              label: "View Reasons",

              children: row.signals?.map((item, index) => (
                <div key={index}>
                  <Tag>{item.factor}</Tag>
                  &nbsp;
                  {item.reason}
                  <br />
                </div>
              )),
            },
          ]}
        />
      ),
    },

    {
      title: "Generated",

      dataIndex: "generated_date",

      render: (v) => dayjs(v).format("DD MMM YYYY"),
    },

    {
      title: "Status",

      dataIndex: "status",

      render: (v) => (
        <Tag
          color={
            v === "approved" ? "green" : v === "rejected" ? "red" : "orange"
          }
        >
          {v}
        </Tag>
      ),
    },

    {
      title: "Action",

      render: (row) => (
        <Space>
          <Button
            icon={<EyeOutlined />}
            onClick={() =>
              navigate("/smart-price/room/" + row.room_id + "/comparison")
            }
          >
            View
          </Button>

          {status === "pending" && (
            <>
              <Button
                type="primary"
                icon={<CheckOutlined />}
                onClick={() => approveSuggestion(row.id)}
              >
                Approve
              </Button>

              <Button
                danger
                icon={<CloseOutlined />}
                onClick={() => {
                  setSelectedId(row.id);

                  setRejectModal(true);
                }}
              >
                Reject
              </Button>
            </>
          )}
        </Space>
      ),
    },
  ];

  return (
    <Layout>
      <LayoutHeader />

      <Content>
        <Card
          title="Smart Price Suggestions"
          extra={
            <Space>
              {status === "pending" && selectedRows.length > 0 && (
                <>
                  <Button type="primary" onClick={bulkApprove}>
                    Bulk Approve
                  </Button>

                  <Button danger onClick={bulkReject}>
                    Bulk Reject
                  </Button>
                </>
              )}

              <Button
                icon={<ReloadOutlined />}
                onClick={() => getSuggestions()}
              >
                Refresh
              </Button>

              <Button
                type="primary"
                icon={<ThunderboltOutlined />}
                onClick={() =>
                  generateSuggestions(dayjs().format("YYYY-MM-DD"))
                }
              >
                Generate Today
              </Button>

              <Button
                icon={<CalendarOutlined />}
                onClick={() => setGenerateModal(true)}
              >
                Generate for Date
              </Button>
            </Space>
          }
        >
          <Tabs
            activeKey={status}
            onChange={(v) => {
              setStatus(v);

              setSelectedRows([]);
            }}
            items={[
              {
                key: "pending",

                label: <Badge count={pagination.total}>Pending</Badge>,
              },

              {
                key: "approved",

                label: "Approved",
              },

              {
                key: "rejected",

                label: "Rejected",
              },

              {
                key: "expired",

                label: "Expired",
              },
            ]}
          />

          <Spin spinning={loading}>
            <Table
              rowSelection={
                status === "pending"
                  ? {
                      selectedRowKeys: selectedRows,

                      onChange: (keys) => {
                        setSelectedRows(keys);
                      },
                    }
                  : undefined
              }
              columns={columns}
              dataSource={data}
              rowKey="id"
              pagination={pagination}
              onChange={(page) => {
                getSuggestions(page.current);
              }}
              scroll={{
                x: 1500,
              }}
            />
          </Spin>
        </Card>
      </Content>

      <LayoutFooter />

      <Modal
        title="Reject Suggestion"
        open={rejectModal}
        onOk={rejectSuggestion}
        onCancel={() => setRejectModal(false)}
      >
        <Input.TextArea
          rows={4}
          placeholder="Enter reject reason"
          value={rejectReason}
          onChange={(e) => setRejectReason(e.target.value)}
        />
      </Modal>

      <Modal
        title="Generate Smart Price Suggestions"
        open={generateModal}
        onCancel={() => setGenerateModal(false)}
        onOk={() => generateSuggestions(generateDate.format("YYYY-MM-DD"))}
      >
        <DatePicker
          value={generateDate}
          style={{ width: "100%" }}
          onChange={(date) => setGenerateDate(date)}
        />
      </Modal>
    </Layout>
  );
}

export default SmartPriceSuggestions;
